// @flow
/* eslint-disable arrow-body-style */
import React from 'react';
import { MotionConfig } from 'framer-motion/dist/framer-motion';
import type { Data, Wording } from '../types';
import Diagram from './Diagram';
import DiagramList from './DiagramList';

type Props = {
  data: Data,
  display: 'diagram' | 'list',
  setDisplay: () => void,
  wording?: Wording,
};

const DiagramDisplay = ({ data, display, setDisplay, wording }: Props): any => {
  return (
    <div>
      <MotionConfig reducedMotion="user">
        <Diagram
          data={data.diagram}
          variant="default"
          display={display}
          setDisplay={setDisplay}
          wording={wording}
        />
      </MotionConfig>
    </div>
  );
};

export default DiagramDisplay;
